<template>
  <div>
    <NavBar :custom="true" @click="onBack">编辑常用行程</NavBar>
    <div class="box">
      <div class="area" @click="onClickAreaTrigger">
        <div class="title">运营区域·</div>
        <div class="info">
          <span v-if="pickerList.length && currentArea">
            {{ currentArea ? currentArea.label : '' }}
          </span>
          <span v-else>（暂无）</span>
        </div>
        <img src="../../../assets//img-v2/ic_home_arrow.png" class="arrow" />
      </div>
      <div class="stop">
        <div class="row" @click="onOnPoiClick">
          <div class="dot"><div class="dot-1"></div></div>
          <input
            class="input"
            type="text"
            placeholder="请输入起点"
            v-model="onStopName"
            :readonly="true"
          />
        </div>
        <div class="row off" @click="onOffPoiClick">
          <div class="dot">
            <div class="dot-2">
              <div class="dot-3"></div>
            </div>
          </div>
          <input
            class="input"
            type="text"
            placeholder="你要去哪儿"
            v-model="offStopName"
            :readonly="true"
          />
        </div>
      </div>
    </div>


    <div class="bottom">
      <div v-show="info && info.id" class="btn remove" @click="onRemove">
        删除本条常用行程
      </div>
      <div class="btn" @click="onSave">保存</div>
    </div>

    <!-- 选择区域 -->
    <AreaPicker
      v-model="modalVisible"
      :default-index="areaIndex"
      :columns="pickerList"
      @confirm="onAreaPickerOk"
      @cancel="onAreaPickerCancel"
    />
  </div>
</template>

<script>
import NavBar from '../../../components/nav-bar'
import AreaPicker from '@/views/home-v2/components/AreaPicker.vue';
import { removeCall, saveCall, updateCall } from '../api'
import { mapGetters } from 'vuex'

export default {
  components: {
    NavBar,
    AreaPicker
  },
  props: {
    info: {
      type: Object
    }
  },
  data() {
    return {
      modalVisible: false,
      saving: false,
      removing: false,
      areaIndex: -1,
      onStop: null, // 上车点
      offStop: null // 下车点
    }
  },
  computed: {
    ...mapGetters({
      areas: 'run/areas',
      currentAreaIndex: 'run/currentAreaIndex',
      dataOnStop: 'dataOnStop',
      dataOffStop: 'dataOffStop',
      userPos: 'dataUserPos'
    }),
    pickerList() {
      if (!this.areas) return []
      const list = this.areas.map((item, index) => {
        return {
          label: item.name,
          value: index,
          id: item.id
        }
      })
      return [list]
    },
    currentArea() {
      const col = this.pickerList[0]
      return col[this.areaIndex]
    },
    onStopName() {
      return this.onStop ? this.onStop.name : ''
    },
    offStopName() {
      return this.offStop ? this.offStop.name : ''
    }
  },
  watch: {
    info: {
      immediate: true,
      handler(obj) {
        if (obj) {
          const col = this.pickerList[0]
          const idx = col.findIndex(
            item => item.id === obj.baseLineId
          )
          this.areaIndex = idx
          this.onStop = {
            id: obj.onId,
            name: obj.onName
          }
          this.offStop = {
            id: obj.offId,
            name: obj.offName
          }
        } else {
          this.areaIndex = this.currentAreaIndex
          this.onStop = null
          this.offStop = null
        }
      }
    }
  },
  activated() {
    if (this.dataOnStop) {
      this.onStop = this.dataOnStop
    }
    if (this.dataOffStop) {
      this.offStop = this.dataOffStop
    }
  },
  destroyed() {
    this.$MapService.setMapDataOnStop(null)
    this.$MapService.setMapDataOffStop(null)
  },
  methods: {
    onBack() {
      this.$emit('back')
    },
    onClickAreaTrigger() {
      if (!this.pickerList.length) {
        this.$toast('当前暂无运营区域')
        return
      }
      this.modalVisible = true
    },
    onAreaPickerOk(value, index) {
      this.modalVisible = false
      if (index !== this.areaIndex) {
        this.areaIndex = index
        this.onStop = null
        this.offStop = null
        this.$MapService.setMapDataOnStop(null)
        this.$MapService.setMapDataOffStop(null)
      }
    },
    onAreaPickerCancel() {
      this.modalVisible = false
    },
    onOnPoiClick() {
      if (!this.currentArea) return
      this.$PoiService.setStopTypeOn()
      this.$nextTick(() => {
        this.$PoiService.turnToPoiView(
          {
            from: 'directCall'
          },
          { type: 'on', areaId: this.currentArea.id }
        )
      })
    },
    onOffPoiClick() {
      if (!this.currentArea) return
      if (!this.onStop) {
        this.$toast('请先选择上车站')
        return
      }
      this.$PoiService.setStopTypeOff()
      this.$nextTick(() => {
        this.$PoiService.turnToPoiView(
          {
            from: 'directCall'
          },
          { type: 'off', areaId: this.currentArea.id, disabledMap: 1 }
        )
      })
    },
    onSave() {
      if (this.saving) return

      if (!this.currentArea) {
        this.$toast('请选择区域')
        return
      }
      if (!this.onStop) {
        this.$toast('请选择上车点')
        return
      }
      if (!this.offStop) {
        this.$toast('请选择下车点')
        return
      }
      this.saving = true
      const { id } = this.info || {}
      const params = {
        baseLineId: this.currentArea.id,
        lineName: this.currentArea.label,
        onId: this.onStop.id,
        offId: this.offStop.id,
        ...(id ? { id } : id)
      }
      const reqApi = id ? updateCall : saveCall
      reqApi(params)
        .then(res => {
          this.saving = false
          this.$toast(res)
          setTimeout(() => {
            this.onBack()
          }, 800)
        })
        .catch(err => {
          console.error(err)
          this.saving = false
          this.$toast(err.msg)
        })
    },
    onRemove() {
      if (this.removing) return
      const { id } = this.info || {}
      if (!id) return
      const userId = this.$UserService.getUserId()
      const cityId = this.$AppService.getCityId()
      this.removing = true
      removeCall({
        userId,
        cityId,
        id
      })
        .then(res => {
          this.$toast(res)
          setTimeout(() => {
            this.onBack()
            this.removing = false
          }, 800)
          // 刷新首页浮窗
          const [lng, lat] = this.userPos || []
          if ((lng, lat)) {
            this.$HomeService.fetchReactiveCall({
              cityId: this.$AppService.getCityId(),
              userId: this.$UserService.getUserId(),
              lat,
              lng
            })
          }
        })
        .catch(err => {
          console.error(err)
          this.removing = false
          this.$toast(err.msg)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  margin: 10px;
  background: #FFFFFF;
  border-radius: 12px;
  padding: 10px 14px 0 14px;
}
.area {
  padding: 13px 0;
  display: flex;
  align-items: center;
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }
  .info {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0,0,0,0.7);
    line-height: 20px;
  }
  .arrow {
    width: 12px;
    height: 12px;
    margin-left: 8px;
  }
}

.stop {
  .dot {
    width: 27px;
  }
  .dot-1 {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #04b47c;
    margin: 0 15px 0 4px;
  }

  .dot-2 {
    padding: 4px;
    border-radius: 50%;
    background: rgba(0, 110, 250, 0.2);
    margin-right: 11px;
  }

  .dot-3 {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #006efa;
  }

  .row {
    padding: 19px 0;
    display: flex;
    align-items: center;
    padding: 14px 0;
  }
  .off {
    border-top: 1px dashed #eeeeee;
  }
  
  .input {
    flex: 1;
    background: none;
    border: none;
    outline: none;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    &::placeholder {
      color: #999999;
    }
  }
}


.picker-header {
  width: 375px;
  height: 74px;
  background: #ffffff;
  border-radius: 13px 13px 0 0;
  position: relative;
  text-align: left;
  padding: 16px 22px;
  .title {
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
  }
  .desc {
    height: 17px;
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 17px;
    margin-top: 3px;
  }
  .close {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 14px;
    right: 14px;
    background-image: url('../../../assets/img/close.png');
    background-position: center;
    background-size: 13px;
    background-repeat: no-repeat;
  }
}
.picker-confirm {
  height: 77px;
  padding: 16px 26px;
}
.picker-btn {
  width: 100%;
  height: 50px;
  background: #1792ff;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom {
  display: flex;
  margin: 10px 10px 0 10px;
}

.btn {
  flex: 1;
  height: 48px;
  background: linear-gradient( 90deg, #00A7FD 0%, #006EFA 100%);
  border-radius: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.remove {
  background: #FFFFFF;
  border: 1px solid #dddddd;
  margin-right: 7px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 22px;
}
</style>
